import script from "./BottomComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomComponent.vue?vue&type=script&setup=true&lang=js"

import "./BottomComponent.vue?vue&type=style&index=0&id=1f654d2c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f654d2c"]])

export default __exports__